<template>
    <div>
        <load-screen-component :isLoading="isLoading"></load-screen-component>
        <page-header :btnNew="this.$hasPermission('PaymentMethod_create') ? 'ACTIONS.NEW' : null" pageTitle="PAYMENT_METHODS.INDEX_TITLE"
                     @newType="setRegisterModal"/>

        <list-component :items="items.data" v-if="items && items.data" :haveDetails="false">
            <template v-slot:principal-info="{items}">
                <div class="list-primary hide-text">{{ items.iten.name }}</div>
            </template>
            <template v-slot:dropdown-options="items">
                <div class="dropdown-item pointer text-white" data-target="#customModalTwo" data-toggle="modal"
                     data-cy="edit-payment-method"
                     @click="setEditModal(items.iten)" v-if="this.$hasPermission('PaymentMethod_update')">
                    <i class="icon-edit mr-2 font-15"/>{{ t('ACTIONS.EDIT') }}
                </div>
                <div class="dropdown-item pointer text-white" data-cy="delete-payment-method"
                     @click="showAlert(items.iten.id)" v-if="this.$hasPermission('PaymentMethod_delete')">
                    <i class="icon-delete mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                </div>
            </template>
        </list-component>

        <pagination-component v-if="items && items.data" :items="items" :to="'/formas-pagamentos'"
                              @changePage="index($event)"></pagination-component>

        <div class="card" v-if="items && !items.data">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('PAYMENT_METHODS.PAYMENTS_METHODS'), os: 'os'}) }}</h5>
                </div>
            </div>
        </div>

        <modal :titleModal="modalTitle">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <form @submit.prevent="create">
                <div class="modal-body">
                    <ModalBodySectionComponent
                            eyebrow="Formas de Pagamento"
                            :title="t(modalTitle)"
                            icon="icon-plus"
                            ></ModalBodySectionComponent>
                    <div class="form-group">
                        <label for="inputName" class="required">{{ t('GENERAL.NAME') }}: </label>
                        <input id="name" v-model="name" class="form-control" name="name" placeholder="Digite o nome"
                               type="text" @keyup="inputName(name)">

                        <label for="ordenation" class="required">{{ t('PAYMENT_METHODS.ORDENATION') }}: </label>
                        <input id="ordenation" v-model="paymentMethod.ordenation" class="form-control" name="ordenation"
                               placeholder="Digite a Ordenação"
                               type="number">

                        <label for="charge_expense">{{ t('PAYMENT_METHODS.CHARGE_EXPENSE') }}: </label>
                        <money3 id="charge_expense" v-model="paymentMethod.charge_expense"
                                name="charge_expense" class="form-control "
                                v-bind="config"></money3>
                        <div class="validation" id="invalidChargeExpense" style="display: none">
                            Valor mínimo R$ 1,00
                        </div>

                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="billet"
                                   v-model="paymentMethod.billet">
                            <label class="custom-control-label" for="billet">{{ t('PAYMENT_METHODS.BILLET') }}</label>
                        </div>

                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="paid_on_due_date"
                                   v-model="paymentMethod.paid_on_due_date">
                            <label class="custom-control-label"
                                   for="paid_on_due_date">{{ t('PAYMENT_METHODS.PAID_ON_DUE_DATE') }}</label>
                        </div>

                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="taxable"
                                   v-model="paymentMethod.taxable">
                            <label class="custom-control-label" for="taxable">{{ t('PAYMENT_METHODS.TAXABLE') }}</label>
                        </div>


                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="show_on_proposal"
                                   v-model="paymentMethod.show_on_proposal">
                            <label class="custom-control-label" for="show_on_proposal">{{
                                    t('PAYMENT_METHODS.SHOW_ON_PROPOSAL')
                                }}</label>
                        </div>


                        <div v-if="isNameInvalid" class="validation">{{ t(msgError) }}</div>
                    </div>
                </div>
                <div class="modal-footer2">
                    <div class="justify-content-left">
                        <h5 class="ml-2" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                    </div>
                    <div class="ml-custom">
                        <button data-cy="payment_method_create_close" class="btn btn-secondary" data-dismiss="modal"
                                type="button">
                            {{ t('ACTIONS.CLOSE') }}
                        </button>
                        <button data-cy="payment_method_create_save" class="btn btn-primary ml-2" type="submit">
                            {{ t('ACTIONS.SAVE') }}
                        </button>
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import {defineComponent} from 'vue';
import {Money3Component} from 'v-money3';
import Modal from "@/components/modal";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import paymentMethods from '@/services/paymentMethods';
import pageHeader from "@/components/layouts/pageHeader";
import ListComponent from '@/components/layouts/listComponent.vue';
import PaginationComponent from "@/components/layouts/PaginationComponent";
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import {mapState} from 'vuex';
import ModalBodySectionComponent from '../../components/layouts/ModalBodySectionComponent';

export default defineComponent({
    name: 'indexPaymenhtMethods',
    mixins: [Validate],
    components: {
        Modal,
        pageHeader,
        ListComponent,
        PaginationComponent,
        money3: Money3Component,
        loadScreenComponent,
        ModalBodySectionComponent,
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading'
        })
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            msg: '',
            id: null,
            type: {},
            items: null,
            modalTitle: '',
            paymentMethod: {charge_expense:0},
            config: {
                min: 0,
                suffix: '',
                masked: true,
                decimal: ',',
                precision: 2,
                prefix: 'R$ ',
                thousands: '.',
                disabled: false,
                allowBlank: false,
                max: 500,
                disableNegative: true,
                minimumNumberOfCharacters: 1
            }
        }
    },

    mounted() {
        this.$canAccess('PaymentMethod_index');
        this.$store.commit('changeLoading', true);
        this.index();
    },

    methods: {
        async index(page = 1) {
            this.$store.commit('changeLoading', true);
            await paymentMethods.index(page).then(resp => {
                this.items = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });

            this.$store.commit('changeLoading', false);
        },

        updatePaginate(page) {
            this.updateItemsFromPaginate(page, paymentMethods)
        },

        setEditModal(iten) {
            this.paymentMethod.id = iten.id;
            this.name = iten.name;
            this.paymentMethod.ordenation = iten.ordenation;
            this.paymentMethod.charge_expense = iten.charge_expense;
            this.paymentMethod.paid_on_due_date = iten.paid_on_due_date;
            this.paymentMethod.billet = iten.billet;
            this.paymentMethod.taxable = iten.taxable;
            this.paymentMethod.show_on_proposal = iten.show_on_proposal;
            this.modalTitle = 'PAYMENT_METHODS.MODAL_TITLE.EDIT';
        },

        setRegisterModal() {
            this.id = null;
            this.name = null;
            this.charge_expense = 0;
            this.ordenation = 0;
            this.paid_on_due_date = false;
            this.billet = false;
            this.taxable = false;
            this.show_on_proposal = false;
            this.modalTitle = 'PAYMENT_METHODS.MODAL_TITLE.ADD';
        },

        showAlert(id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);

                    paymentMethods.delete(id).then(resp => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(resp.data.validations.message);

                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error)
                    });
                }
            });
        },

        create() {
            this.startForm();

            if (this.checkForm()) {
                this.$store.commit('changeLoading', true);
                if (this.type.id) {
                    let data = this.type
                    let value = data.charge_expense
                    if (value){
                        value = value.replace('R$ ', '');
                        value = value.replaceAll(".", "");
                        value = value.replaceAll(",", ".");
                        value = parseFloat(value).toFixed(2);
                        data.charge_expense = value;
                    }
                    if (data.charge_expense === undefined){
                        data.charge_expense = 0.00
                    }
                    paymentMethods.update(data).then(() => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.UPDATE_SUCCESS'));
                        this.paymentMethod = {};
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                } else {
                    let data = this.type
                    let value = data.charge_expense
                    if (value){
                        value = value.replace('R$ ', '');
                        value = value.replaceAll(".", "");
                        value = value.replaceAll(",", ".");
                        value = parseFloat(value).toFixed(2);
                        data.charge_expense = value;
                    }
                    if (data.charge_expense === undefined){
                        data.charge_expense = 0.00
                    }
                    paymentMethods.create(data).then(() => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.REGISTER_SUCCESS'));
                        this.paymentMethod = {};
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                }
            }
        },

        checkForm() {
            this.nameValidate(this.name);

            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },

        startForm() {
            this.type = {
                id: this.paymentMethod.id,
                name: this.name,
                ordenation: this.paymentMethod.ordenation,
                charge_expense: this.paymentMethod.charge_expense,
                paid_on_due_date: this.paymentMethod.paid_on_due_date ?? false,
                billet: this.paymentMethod.billet ?? false,
                taxable: this.paymentMethod.taxable ?? false,
                show_on_proposal: this.paymentMethod.show_on_proposal ?? false,
            }
            this.invalid = [];
        },

    }
});
</script>

<style>
.zIndex {
    z-index: 100000000000 !important;
}
</style>